import { render, staticRenderFns } from "./WoocommyFooter.vue?vue&type=template&id=51cb7e64&"
import script from "./WoocommyFooter.vue?vue&type=script&lang=js&"
export * from "./WoocommyFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports